var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.asyncDataStatus_ready)?_c('div',{staticClass:"col-full push-top"},[_c('h1',[_vm._v("Editing "),_c('i',[_vm._v(_vm._s(_vm.thread.title))])]),_vm._v(" "),_c('ThreadEditor',{ref:"editor",attrs:{"title":_vm.thread.title,"text":_vm.text},on:{"save":_vm.save,"cancel":_vm.cancel}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c6a29d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageThreadEdit.vue
// module id = I/aD
// module chunks = 1